import { BaseConditionData } from './base-condition-data';
import { ComparisonType } from './Enums/comparaison-type';
import { WorkflowConditionTypes } from './Enums/workflow-condition-types';

/**
 * Représente les données d'une condition 'La comparaison entre La valeur de l'attribut spécifié * et la valeur de reference doit être respectée'.
 */
export class AttributeValueConditionData extends BaseConditionData {
    /**
     * Identifiant de l'attribut.
     */
    public attributeId: number = null;

    /**
     * Valeur de comparaison.
     */
    public comparaisonValue: string = null;

    /// <summary>
    /// Type de comparaison effectuée.
    /// </summary>
    public comparisonType: ComparisonType = null;

    /**
     * Constructeur.
     */
    constructor() {
        super(WorkflowConditionTypes.AttributeValue);
    }

    /**
     * Retourne une copie d'une instance de AttributeValueConditionData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: AttributeValueConditionData) {
        if (!!other) {
            const instance = new AttributeValueConditionData();
            instance.attributeId = other.attributeId;
            instance.comparaisonValue = other.comparaisonValue;
            instance.comparisonType = other.comparisonType;
            instance.name = other.name;
            instance.type = other.type;
            instance.id = other.id;
            instance.isMainCondition = other.isMainCondition;

            return instance;
        } else {
            return null;
        }
    }
}
